import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { editionSelector } from '../selectors/userSelectors';
import { getUserRequest, cleanUser } from '../actions/userActions';
import UserDetail from '../components/UserDetail/UserDetail';

const mapStateToProps = createStructuredSelector({ edition: editionSelector });
const mapDispatchToProps = {
    getUserRequest,
    cleanUser
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
